import { get } from 'lodash'
import { TextField } from 'beam/dist/TextField'
import fieldPropTypes from './FieldPropTypes'

const FormTextField = props => {
  const {
    classes,
    label,
    field,
    required,
    textFieldProps,
    type,
    form: { errors, touched },
  } = props
  return (
    <TextField
      {...field}
      type={type ? type : 'text'}
      value={field.value !== undefined && field.value !== null ? field.value : ''}
      label={label}
      required={required}
      error={!!get(touched, field.name) && !!get(errors, field.name)}
      helperText={!!get(touched, field.name) && get(errors, field.name)}
      classes={classes}
      fullWidth={true}
      {...textFieldProps}
    />
  )
}

FormTextField.propTypes = fieldPropTypes

export default FormTextField
